import { FaWhatsapp, FaVideo } from "react-icons/fa";
import { IoVideocam } from "react-icons/io5";
import { useEffect } from "react";
import "./WhatsAppButton.css";

const WhatsAppButton = () => {
  useEffect(() => {
    // Load Calendly CSS
    const link = document.createElement("link");
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    // Load Calendly Script
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, []);

  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/arsaifrehman/30min",
      });
    }
  };

  return (
    <>
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/33605905713?text=Hi%20I%20want%20to%20discuss%20a%20project"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn"
      >
        <FaWhatsapp />
      </a>

      <button className="calendly-btn" onClick={openCalendly}>
        <div className="calendly-content">
          <IoVideocam className="video-icon" />
          <span className="calendly-text">Book Appointment</span>
        </div>
      </button>
    </>
  );
};

export default WhatsAppButton;